import { Component, OnInit, EventEmitter  } from '@angular/core';
import { UserManagementService } from 'app/services/user-management.service';
import { StateService } from '@uirouter/angular';
import { TranslateService } from '@ngx-translate/core';
import { HttpCustomService } from "app/services/http-custom.service";
import { DataService } from "app/services/data.service";
import { LogService } from 'app/services/log.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
    username_error = false;
    errorMessage = '';
    password_error = false;
    username = '';
    password = '';
    sendState = "login";
    fullScreenLoader = false;
    user_id: any;

    // Focus variables
    public  username_focus =  new EventEmitter<boolean>();
    public  password_focus =  new EventEmitter<boolean>();

    constructor(
        private user_management_service: UserManagementService,
        private httpService: HttpCustomService,
        public dataService: DataService,
        private stateService: StateService,
        private translate: TranslateService,
        private logService: LogService
    ) {
    }

    ngOnInit() {
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('currentUser');
    }

    onSubmit(user) {
        const regEx = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

        if ((user.username.trim() === '') || user.username === undefined) {
            this.username = '';
            this.username_focus.emit(true);
            this.username_error = true;
            this.errorMessage = 'enter_an_email_id'
        } else if (!regEx.test(user.username)) {
            this.username_error = true;
            this.errorMessage = 'enter_a_valid_email_id'
        } else if ( user.password.trim() === '' || user.password === undefined) {
            this.password = '';
            this.password_focus.emit(true);
            this.password_error = true;
            this.username_error = false;
            this.errorMessage = 'enter_your_password'
        } else {
            this.username_error = false;
            this.password_error = false;
            this.fullScreenLoader = true;
            this.user_management_service.login(user, (resp) => {
                this.fullScreenLoader = false;
                if(resp.status === true) {
                    localStorage.setItem('currentUser', JSON.stringify({
                        token: resp.data.access_token,
                        refresh_token: resp.data.refresh_token,
                        token_type: resp.data.token_type,
                        id: resp.data.id,
                    }));

                    localStorage.setItem('isLoggedIn', 'true');

                    this.user_management_service.getUserProfile(resp.data.id, (response) => {
                        if(response.status) {
                            const userDetails = response['data'];
                            this.dataService.setCurrentUserDetails(userDetails);
                            this.user_management_service.getLanguagePreference(userDetails.id, (response2) => {
                                if(response2.status === true) {
                                    localStorage.setItem('selectedLang', response2.data.lang);

                                    const redirect = localStorage.getItem('redirect_url');
                                    localStorage.removeItem('redirect_url');

                                    if(redirect !== "/login" && redirect !== null) {
                                        this.logService.printLog(redirect);
                                        window.location.href = redirect;
                                    } else {
                                        if (this.dataService.projectModuleEnabled) {
                                            window.location.href = '/projects';
                                        } else {
                                            window.location.href = '/tasks';
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
            });
        }
    }
}

